import React, { Component } from 'react';
import Typography from 'material-ui/Typography';

class Subdevice extends Component {
  render() {
    const device = this.props.device;

    if (device.name) {
      return (
        <div>
          <Typography variant="display1" gutterBottom align="center">
            { device.name }
          </Typography>

          <Typography variant="body1" gutterBottom align="center">
            { device.description }
          </Typography>
        </div>
      )
    } else {
      return (
        <div>
          <Typography variant="body1" gutterBottom align="center">
            { device.description }
          </Typography>
        </div>
      )
    }
  }
}

export default Subdevice;



// WEBPACK FOOTER //
// ./src/components/Subdevice.js